// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll_display {
  overflow-x: hidden;
  overflow-y: auto;
}
.scroll_display::-webkit-scrollbar {
  width: 3px;
  height: 5px;
  background-color: #000;
}
.scroll_display::-webkit-scrollbar-thumb {
  background-color: #999999;
}

.music_result {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}
@media screen and (min-width: 2400px) {
  .music_result {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media screen and (min-width: 1800px) and (max-width: 2400px) {
  .music_result {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (min-width: 1360px) and (max-width: 1800px) {
  .music_result {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 1360px) {
  .music_result {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchResult/index.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;AACJ;AACI;EACE,UAAA;EACA,WAAA;EACA,sBAAA;AACN;AAEI;EACE,yBAAA;AAAN;;AAIE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AADJ;AAII;EANF;IAOI,qCAAA;EADJ;AACF;AAII;EAXF;IAYI,qCAAA;EADJ;AACF;AAII;EAhBF;IAiBI,qCAAA;EADJ;AACF;AAII;EArBF;IAsBI,0BAAA;EADJ;AACF","sourcesContent":[".scroll_display {\n    overflow-x: hidden; // Prevent horizontal scrolling\n    overflow-y: auto;   // Enable vertical scrolling\n  \n    &::-webkit-scrollbar {\n      width: 3px; // Set the scrollbar width\n      height: 5px; // Set the scrollbar height for horizontal scrollbars (if any)\n      background-color: #000; // Background of the scrollbar track\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background-color: #999999; // Color of the scrollbar thumb\n    }\n  }\n  \n  .music_result {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); // Responsive column layout\n    gap: 10px; // Space between items\n  \n    // Grid layout for extra large screens\n    @media screen and (min-width: 2400px) {\n      grid-template-columns: repeat(4, 1fr); // 4 columns on screens wider than 2400px\n    }\n  \n    // Grid layout for large screens\n    @media screen and (min-width: 1800px) and (max-width: 2400px) {\n      grid-template-columns: repeat(3, 1fr); // 3 columns for screens between 1800px and 2400px\n    }\n  \n    // Grid layout for medium screens\n    @media screen and (min-width: 1360px) and (max-width: 1800px) {\n      grid-template-columns: repeat(2, 1fr); // 2 columns for screens between 1360px and 1800px\n    }\n  \n    // Grid layout for smaller screens\n    @media screen and (max-width: 1360px) {\n      grid-template-columns: 1fr; // Single column layout for screens narrower than 1360px\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
